const defaultPath = "reports";
const defaultPathName =
  defaultPath.charAt(0).toUpperCase() + defaultPath.slice(1);

export const reportsRouters = [
  {
    name: `${defaultPathName}Home`,
    path: `/${defaultPath}`,
    component: () => import(`../../views/${defaultPath}/Home.vue`),
  },
  {
    name: `${defaultPathName}Overdue`,
    path: `/${defaultPath}/overdue`,
    component: () => import(`../../views/${defaultPath}/Overdue.vue`),
  },
  {
    name: `${defaultPathName}PopularBooks`,
    path: `/${defaultPath}/popular-books`,
    component: () => import(`../../views/${defaultPath}/PopularBooks.vue`),
  },
  {
    name: `${defaultPathName}LibraryUsage`,
    path: `/${defaultPath}/library-usage`,
    component: () => import(`../../views/${defaultPath}/LibraryUsage.vue`),
  },
  {
    name: `${defaultPathName}StudentStats`,
    path: `/${defaultPath}/student-stats`,
    component: () => import(`../../views/${defaultPath}/StudentStats.vue`),
  },
  {
    name: `${defaultPathName}Trends`,
    path: `/${defaultPath}/trends`,
    component: () => import(`../../views/${defaultPath}/Trends.vue`),
  },
  {
    name: `${defaultPathName}Inventory`,
    path: `/${defaultPath}/inventory`,
    component: () => import(`../../views/${defaultPath}/Inventory.vue`),
  }
]; 